import { useNotifications } from '../context/NotificationsContext';
import { BellIcon, HeartEnvelopeIcon, MatchBadgeIcon, MessageIcon } from './SvgIcons';

const getTypeIcon = (type) => {
  if (type === 'like')    return <HeartEnvelopeIcon size={20} />;
  if (type === 'match')   return <MatchBadgeIcon size={20} />;
  if (type === 'message') return <MessageIcon size={20} />;
  return <BellIcon size={20} color="white" />;
};

export default function NotificationToast() {
  const { toast, setToast } = useNotifications();
  if (!toast) return null;

  return (
    <div style={s.wrap} onClick={() => setToast(null)}>
      <span style={s.icon}>{getTypeIcon(toast.type)}</span>
      <div style={s.text}>
        <p style={s.title}>{toast.title}</p>
        {toast.body && <p style={s.body}>{toast.body}</p>}
      </div>
      <button style={s.close} onClick={() => setToast(null)}>✕</button>
    </div>
  );
}

const s = {
  wrap: { position: 'fixed', top: '16px', left: '50%', transform: 'translateX(-50%)', zIndex: 1000, display: 'flex', alignItems: 'center', gap: '10px', backgroundColor: 'var(--btn-solid-bg)', color: 'white', borderRadius: '14px', padding: '12px 16px', boxShadow: '0 8px 24px rgba(0,0,0,0.25)', maxWidth: '360px', width: 'calc(100vw - 32px)', cursor: 'pointer', fontFamily: 'inherit', animation: 'slideDown 0.2s ease' },
  icon: { flexShrink: 0, display: 'flex', alignItems: 'center' },
  text: { flex: 1, minWidth: 0 },
  title: { margin: 0, fontSize: '14px', fontWeight: '700', lineHeight: 1.3 },
  body: { margin: '2px 0 0', fontSize: '12px', color: 'rgba(255,255,255,0.75)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  close: { background: 'none', border: 'none', color: 'rgba(255,255,255,0.6)', fontSize: '14px', cursor: 'pointer', padding: '2px', flexShrink: 0 },
};
